import { blockCategories } from '../../categories';

export default (editor) => {
    const blockManager = editor.BlockManager;
    const domComponents = editor.DomComponents;

    blockManager.add('paragraph', {
        label: 'Absatz',
        category: blockCategories.basic,
        content: {
            type: 'paragraph',
            content: 'Insert your text here',
            classes: ['sio-paragraph'],
        },
        media: `<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <text x="12" y="20" font-size="24" font-weight="bold" text-anchor="middle" fill="currentColor">P</text>
        </svg>`,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const textType = domComponents.getType('text');
    const textView = textType.view;

    domComponents.addType('paragraph', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Paragraph',
                tagName: 'p',
                droppable: true,
                editable: true,
            }),
        },
        view: textView,
    });
};
